import * as e from "react";
import { forwardRef as t } from "react";
import { c as o } from "./index.js-Cr0Rsuyz.mjs";
function a(r, l) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h14.5A.75.75 0 0 1 20 12",
    clipRule: "evenodd"
  }), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 12 4",
    clipRule: "evenodd"
  }));
}
var c = o(/* @__PURE__ */ t(a));
export {
  c as I
};
